import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * No-Auth Guard - Protects routes that should ONLY be accessed when NOT authenticated
 * 
 * Use for: Login, Register, Forgot Password pages
 * 
 */
export const noAuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated() && localStorage.getItem('userLogin') === 'true') {
    // User is already logged in, redirect to dashboard or returnUrl
    const returnUrl = route.queryParams['returnUrl'];
    router.navigateByUrl(returnUrl || '/dashboard');
    return false;
  }

  // User is not authenticated, allow access to auth pages
  return true;
};
